var map = {
	"./flag-ar.svg": 2667,
	"./flag-de.svg": 8575,
	"./flag-en.svg": 6155,
	"./flag-es.svg": 1518,
	"./flag-fr.svg": 9014,
	"./flag-pt.svg": 7522,
	"./flag-ru.svg": 6781,
	"./flag-tr.svg": 5936,
	"./flag-usa.svg": 5571
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1888;